// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R
import './CsvDownloadButton.scss';
import { useTranslation } from 'react-i18next';
import { IconDownload } from '../icons/IconDownload';
import CustomCSVLink from '../CustomCsvLink';

type CsvDownloadButtonProps = {
  onClick?: VoidFunction;
  fileName: string;
  headers: string[];
  fetchData: string[][];
};

export const CsvDownloadButton = (props: CsvDownloadButtonProps) => {
  const { t } = useTranslation();

  return (
    <CustomCSVLink
      className="csv-button"
      onClick={props.onClick}
      filename={props.fileName + '.csv'}
      headers={props.headers}
      data={props.fetchData}
    >
      <IconDownload />
      {t('common.csv_download')}
    </CustomCSVLink>
  );
};
